import React, { FC } from 'react'
import s from './MoreAboutUs.module.scss'
import parse from 'html-react-parser'

interface Section {
    id: number;
    title: string;
    description: string;
}

interface MoreAboutUsProps {
    sections?: Section[];
}

const MoreAboutUs: FC<MoreAboutUsProps> = ({ sections }) => {
    if (!sections || sections.length === 0) {
        return null;
    }

    return (
        <section className={s.section}>
            <div className='container'>
                <h2 className='title'> <span />Подробнее о нас</h2>
                <div className={s.sections}>
                    {sections.map((section) => (
                        <div key={section.id} className={s.sectionItem}>
                            <h3 className={s.sectionTitle}>{section.title}</h3>
                            <p className={s.sectionDescription}>{section.description}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className={`${s.shapeRight}`} />
                        <span className={`${s.gradientLine} lineGradient bottom-line`} />
        </section>
    )
}

export default MoreAboutUs